import type { IconData } from '@stacksjs/iconify-core'

export const airplaneDisabledSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.792 13.256L7.768 4.232a2.5 2.5 0 0 0-3.536 3.536l38 38a2.5 2.5 0 0 0 3.536-3.536L34.1 30.565l9.915 2.478a2 2 0 0 0 2.485-1.94V29.03a3.5 3.5 0 0 0-1.784-3.05l-13.945-7.845c.187-1.952.369-3.995.537-6.09a.5.5 0 0 0-.003-.106c-.683-5.23-3.32-8.013-5.197-9.354a3.59 3.59 0 0 0-4.216 0c-1.876 1.341-4.514 4.123-5.197 9.354a.5.5 0 0 0-.003.105zm17.036 28.285l-.792-.884L12.93 20.552l-9.647 5.426a3.5 3.5 0 0 0-1.784 3.05v2.075a2 2 0 0 0 2.485 1.94l14.469-3.617c.259 2.14.53 4.278.828 6.412l-5.11 5.703a4.5 4.5 0 0 0-1.148 3.003v1.027a1.5 1.5 0 0 0 2.036 1.4L24 43.55l8.94 3.422a1.5 1.5 0 0 0 2.036-1.401v-1.027a4.5 4.5 0 0 0-1.148-3.003\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default airplaneDisabledSolid
